"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _constants = require("../../constants");

var _utils = require("../../utils");

var _Yup$object$shape;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var billingSchema = Yup.object().shape((_Yup$object$shape = {}, _defineProperty(_Yup$object$shape, _constants.ACCOUNT_ADDRESS_1, Yup.string().matches(/^[^!@$%^&*(){}:"<>;'_|]+$/, {
  message: 'The following special characters are allowed: . , - #',
  excludeEmptyString: true
})), _defineProperty(_Yup$object$shape, _constants.ACCOUNT_ADDRESS_2, Yup.string().matches(/^[^!@$%^&*(){}:"<>;'_|]+$/, {
  message: 'The following special characters are allowed: . , - #',
  excludeEmptyString: true
})), _defineProperty(_Yup$object$shape, _constants.ACCOUNT_CITY, Yup.string().matches(/^[A-Za-z\s]+$/, {
  message: 'No numbers or special characters allowed',
  excludeEmptyString: true
})), _defineProperty(_Yup$object$shape, _constants.ACCOUNT_COUNTRY, Yup.string().required('Country is required')), _defineProperty(_Yup$object$shape, _constants.ACCOUNT_POSTAL_CODE, Yup.string().when(_constants.ACCOUNT_COUNTRY, {
  is: 'United States',
  then: Yup.string().matches(/^[0-9-]+$/, {
    message: 'No letters or special characters allowed',
    excludeEmptyString: true
  }).matches(/^\d{5}(?:[-\s]\d{4})?$/, {
    message: 'Must be a well formed postal code (e.g. 98126 or 85297-2176)',
    excludeEmptyString: true
  }),
  otherwise: Yup.string().matches(/^[0-9A-Za-z]{3}\s[0-9A-Za-z]{3}$/, {
    message: 'Must be a well formed postal code (e.g. M4S 2N3)'
  }).length(7, 'Must be a well formed postal code (e.g. M4S 2N3)')
})), _defineProperty(_Yup$object$shape, _constants.ACCOUNT_STATE, Yup.string().required('Required')), _defineProperty(_Yup$object$shape, _constants.CARD_NAME, Yup.string().required('Name on card is required')), _defineProperty(_Yup$object$shape, _constants.CARD_NUMBER, Yup.string().transform(function (current, original) {
  // prevents the formatted cc value with spaces from being validated,
  // which happens when you copy/paste a cc number in to the input
  return (0, _utils.numbersOnly)(current);
}).matches(_utils.cardValidationRegEx, {
  message: 'This card is not valid',
  excludeEmptyString: true
}).required('Card number is required')), _defineProperty(_Yup$object$shape, _constants.EXPIRATION_MONTH, Yup.string().max(4).required('Required')), _defineProperty(_Yup$object$shape, _constants.EXPIRATION_YEAR, Yup.string().max(4).test('cardIsExpired', 'Card is expired', function (value) {
  var ccMonth = this.parent[_constants.EXPIRATION_MONTH];
  return !(0, _utils.cardIsExpired)(ccMonth, value);
}).required('Required')), _defineProperty(_Yup$object$shape, _constants.SECURITY_CODE, Yup.string().test('cvvInvalid', 'CVC is invalid', function (value) {
  var ccNum = this.parent[_constants.CARD_NUMBER];
  return value ? !(0, _utils.cvvLengthInvalid)(ccNum, value) : true;
}).required('CVC is required')), _defineProperty(_Yup$object$shape, _constants.PAYMENT_SAME_AS_BILLING, Yup.boolean()), _Yup$object$shape));
var _default = billingSchema;
exports.default = _default;